






import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'lazy-load',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop() private component: string;
  @Prop({default: () => ({})}) private props!: object;

  private observer: IntersectionObserver | null = null;
  private componentToLoad: string = '';

  private mounted(): void {
    if (!window.IntersectionObserver) {
      this.componentToLoad = this.component;
      return;
    }

    const options = {
      root: null,
      rootMargin: '0px 0px 200px 0px',
      threshold: 0
    };

    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        this.componentToLoad = this.component;
      }
    }, options);

    this.observer.observe(this.$el);
  }

  private destroyed(): void {
    this.observer.disconnect();
  }
}
